import { lazyInitializeNotificationDiagnostics } from 'owa-mail-notification-diagnostics';
import { lazyInitializeNotificationManager } from 'owa-notification';
import { handleAuthError } from 'owa-service-error';
import { getScopedPath } from 'owa-url';
import { getHostLocation } from 'owa-url/lib/hostLocation';
import { isOpx } from 'owa-opx';

export default async function initializeNotifications() {
    const initializeNotificationDiagnostics = await lazyInitializeNotificationDiagnostics.import();
    await initializeNotificationDiagnostics();
    await lazyInitializeNotificationManager.importAndExecute({
        channelEndpoint: getScopedPath('/owa') + '/notificationchannel',
        pingInterval: 300000,
        backoffMaximum: 64000,
        minimumReconnectInterval: 1000,
        readyCheckTimeout: 60000,
        handleSessionTimeout: () => {
            handleAuthError(getHostLocation(), onAuthError);
        },
    });
}

async function onAuthError() {
    if (isOpx()) {
        /**
         * Add the opxHostApi.onFatalError() call back once notifications are
         * supported in OPX. See #84291 for context.
         */
        return true;
    }
    return false;
}
